import axiosInstance from 'services/api';
import getMyManagerProfile from './application/useCases/getMyManagerProfile';
import RestManagerProfileRepository from './infrastructure/RestManagerProfileRepository';

const managerProfileRepository = new RestManagerProfileRepository({ axiosInstance });

const getMyManagerProfileUseCase = getMyManagerProfile({ managerProfileRepository });

export { getMyManagerProfileUseCase as getMyManagerProfile };
